import { Controller } from "@hotwired/stimulus";

// Handles the "configure provider intelligence" gear icon on a search result
// card (and the matching one in the provider details drawer header).
//
// On click:
//   1. Fetch a small JSON precheck endpoint to find out if this NPI resolves
//      to any Locations or EINs.
//   2. If it does, open the PI page in a new tab with `?drawer=…` so the
//      configure-for-NPI drawer auto-opens (see docs/drawers.md). The admin
//      configures the settings there; the original /search tab is left
//      untouched (a fresh search picks up the new badges).
//   3. If it doesn't, reveal the empty-state modal that lives at the bottom
//      of the page (#configure-pi-empty-state-modal) explaining why we can't
//      attach a setting.
export default class extends Controller {
  static values = { precheckUrl: String };

  async open(event) {
    event.preventDefault();
    event.stopPropagation();

    let response;
    try {
      response = await fetch(this.precheckUrlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
    } catch {
      this.showEmptyStateModal();
      return;
    }
    if (!response.ok) {
      this.showEmptyStateModal();
      return;
    }

    const data = await response.json();
    if (data.has_entities && data.target_url) {
      window.open(data.target_url, "_blank", "noopener");
    } else {
      this.showEmptyStateModal();
    }
  }

  showEmptyStateModal() {
    const modal = document.getElementById("configure-pi-empty-state-modal");
    if (modal) modal.classList.remove("hidden");
  }
}
